import initialMetricsPublisher from 'src/metrics';
import * as KatalMetrics from '@amzn/katal-metrics';

export const setupGlobalErrorHandler = () => {
    const errorMetricsPublisher =
        initialMetricsPublisher.newChildActionPublisherForMethod(
            'JavaScriptError'
        );
    let errorRedirecting = false;

    const redirectToError = () => {
        if (!errorRedirecting) {
            errorRedirecting = true;
            setTimeout(() => {
                window.location.replace('/error');
            }, 100);
        }
    };

    const truncateString = (str: string, maxLength: number = 200) => {
        return str.length > maxLength
            ? str.substring(0, maxLength) + '...'
            : str;
    };

    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
        event.preventDefault();
        try {
            const errorData = {
                type: 'unhandledrejection',
                reason: truncateString(
                    event.reason?.toString() || 'Unknown rejection'
                ),
                stack: truncateString(
                    event.reason?.stack || 'No stack trace available'
                ),
                url: truncateString(window.location.href),
                timestamp: new Date().toISOString(),
            };

            errorMetricsPublisher.publish(
                new KatalMetrics.Metric.String(
                    'gru.error.unhandledrejection',
                    JSON.stringify(errorData)
                )
            );
        } catch (metricsError) {
            console.error('Failed to publish error metrics:', metricsError);
        }

        redirectToError();
    });

    // Handle uncaught JavaScript errors
    window.addEventListener('error', (event) => {
        try {
            const errorData = {
                type: 'javascript',
                message: truncateString(event.message),
                filename: truncateString(event.filename || ''),
                lineno: event.lineno,
                colno: event.colno,
                stack: truncateString(
                    event.error?.stack || 'No stack trace available'
                ),
                url: truncateString(window.location.href),
                timestamp: new Date().toISOString(),
            };

            errorMetricsPublisher.publish(
                new KatalMetrics.Metric.String(
                    'gru.error.javascript',
                    JSON.stringify(errorData)
                )
            );
        } catch (metricsError) {
            console.error('Failed to publish error metrics:', metricsError);
        }

        redirectToError();
    });
};
